"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalytics = exports.initAnalytics = void 0;
var AdobeAnalytics_1 = __importDefault(require("./module/AdobeAnalytics"));
var GoogleAnalytics_1 = __importDefault(require("./module/GoogleAnalytics"));
var AnalyticsModuleMap = {
    adobe: AdobeAnalytics_1.default,
    google: GoogleAnalytics_1.default,
};
var analyticsModules;
function initAnalytics(options) {
    analyticsModules = options.reduce(function (acc, option) {
        var analyticsModuleItem = AnalyticsModuleMap[option.type];
        if (!analyticsModuleItem) {
            // we want to warn the user without breaking app
            /* eslint-disable no-console */
            console.warn('Invalid analytics module type');
        }
        /* eslint-disable no-param-reassign */
        acc = __spreadArray(__spreadArray([], acc, true), [analyticsModuleItem(option)], false);
        return acc;
    }, []);
}
exports.initAnalytics = initAnalytics;
var useAnalytics = function () {
    if (analyticsModules.length === 0) {
        throw Error("Analytics module uninitialized. Please call 'initAnalytics' method at the root of your app");
    }
    /* eslint-disable @typescript-eslint/no-explicit-any */
    var fireTrackingEvent = function (eventName, payload) {
        analyticsModules.forEach(function (module) {
            return module.fireTrackingEvent(eventName, payload);
        });
    };
    return {
        fireTrackingEvent: fireTrackingEvent,
    };
};
exports.useAnalytics = useAnalytics;
//# sourceMappingURL=useAnalytics.js.map